module.exports = __webpack_public_path__ + "img/ansRightBox.e0840277.png";